var render, staticRenderFns
import script from "./VDataTable.vue?vue&type=script&lang=ts"
export * from "./VDataTable.vue?vue&type=script&lang=ts"
import style0 from "./VDataTable.vue?vue&type=style&index=0&id=a6c3f90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c3f90e",
  null
  
)

export default component.exports